import { ControlType, Field, Section } from "@cotecna/dynamic-view-engine";
import { environment } from "src/environments/environment";
import { PRESET_ID } from "../../constants/constants";
import { CLIENT_FIELD_ID } from "../../static-forms/general-info-form";

export const IMPORT_INSPECTIONS_FIELDS: Field[] = [
  {
    id: PRESET_ID,
    type: ControlType.Dropdown,
    label: "Inspection Preset",
    order: 1,
    propertyName: "inspectionPreset",
    value: null,
    required: true,
    visible: true,
    valid: true,
  },
  {
    id: CLIENT_FIELD_ID,
    type: ControlType.Autocomplete,
    label: "Client",
    order: 4,
    propertyName: CLIENT_FIELD_ID,
    value: null,
    required: true,
    visible: true,
    valid: false,
  },
];

export const IMPORT_INSPECTIONS_SECTIONS: Section[] = [
  {
    id: "1",
    name: "",
    order: 1,
    isFixed: true,
    fields: IMPORT_INSPECTIONS_FIELDS,
    actions: [],
  },
];

export const IMPORT_INSPECTIONS_CONTROLS: any[] = [
  {
    id: PRESET_ID,
    options: [],
  },
  {
    id: CLIENT_FIELD_ID,
    datasourceUrl: `${environment.webApiUrl}/api/account/clients?search=`,
    datasourceHeaders: { RequesterApp: "web" },
    dataProp: "",
    idProp: "id",
    valueProp: "name",
    maxLength: 50,
  },
];
